exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-input[data-v-38c732d4]{color:#606266;width:100%;height:40px;padding:0 15px;border-radius:4px;border:1px solid #DCDFE6}.search-input[data-v-38c732d4]::-webkit-input-placeholder{color:#ccced4 !important}.role-main[data-v-38c732d4]{padding:20px}.select-btn[data-v-38c732d4]{margin-bottom:20px}\n", ""]);

// exports
